export default {
  account: {
    attributes: {
      name: 'Nombre',
      type: 'Tipo',
    },
    header: {
      title: 'Servicio de Email',
      subtitle: 'Aprende a integrar un servicio de correo electrónico',
      searchAccount: 'Buscar una Cuenta',
    },
    list: {
      insert_date: 'Adicionado en',
      actions: 'Acciones',
      deprecated: 'Obsoleto',
    },
    editModal: {
      header: 'Añade una cuenta de servicio de e-mail',
      helpBlock: 'Completa el formulario de aquí abajo por favor.',
      select: 'Selecciona',
      save: 'Guardar',
      activeCampaign: {
        apiKey: 'Key',
        apiKeyPlaceholder: 'API Key',
        apiUrl: 'URL',
        apiUrlPlaceholder: 'API URL',
      },
      aweber: {
        help: 'Para finalizar la integración con Aweber, haz clic en botón Guardar.',
      },
      convertKit: {
        apiKey: 'Key',
        apiKeyPlaceholder: 'API Key',
        apiSecret: 'Secret',
        apiSecretPlaceholder: 'API Secret',
      },
      eGoi: {
        apiKey: 'Tu API Key',
      },
      getResponse: {
        apiKey: 'GetResponse API Key',
        apiKeyPlaceholder: 'API Key',
      },
      mailChimp: {
        apiKey: 'Mailchimp API Key',
        apiKeyPlaceholder: 'API Key',
      },
      rdStation: {
        apiKey: 'Tu Token',
        apiKeyPlaceholder: 'Token',
        help: 'Para finalizar la integración con el RD Station, haga clic en el botón Guardar que está a continuación.',
      },
    },
    types: {
      getResponse: 'GetResponse',
      activeCampaign: 'Active Campaign',
      aweber: 'Aweber',
      convertKit: 'ConvertKit',
      eGoi: 'E-Goi',
      mailChimp: 'MailChimp',
      rdStation: 'RD Station',
    },
    actions: {
      new: 'NUEVA CUENTA',
      open: 'Abrir',
      edit: 'Editar',
      delete: 'Eliminar',
    },
    empty: {
      title: 'Haz que todo sea más fácil con Hotmart Send o integra tus servicios de correo electrónico con las páginas que crees',
      subtitle: 'Descubre nuestro servicio de email para captar leads (contactos),<br/> crear segmentaciones y enviar correos electrónicos. También puede conectar cuentas de otros servicios.',
      link: 'Aprenda a integrar un servidor de correo electrónico  ',
      klicksend: 'Conociendo Hotmart Send',
      button: 'Integrar correo electrónico',
      url: 'https://klickpageshelp.zendesk.com/hc/pt-br/sections/360010144511-Conta-Integrada',
      urlExtensions: 'https://help.hotmart.com/pt-BR/section/criador-de-paginas-formulario-de-pesquisa/360012998471',
    },
    notify: {
      success: {
        delete: 'Servicio de e-mail removido con éxito.',
        create: 'Servicio de e-mail guardado con éxito.',
        update: 'Servicio de e-mail actualizado con éxito.',
      },
      error: {
        aweber: 'Se produjo un error en la conexión con aweber',
        rdstation: 'Se produjo un error en la conexión con el RDStation',
      },
    },
  },
  modal: {
    delete: {
      title: 'EXCLUIR',
      message: '¿Tienes certeza que deseas excluir este servicio de email? ¡Esta acción es irreversible!',
      confirm: 'Sí, Excluir',
      cancel: 'Cancelar',
    },
  },
  notifications: {
    noNotifications: 'No hay notificaciones nuevas.',
    unableLoad: 'No pudimos cargar notificaciones en este momento.',
  },
};



// WEBPACK FOOTER //
// ./src/i18n/messages/languages/es.js